var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7516_9629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4395 23.2778C10.4772 22.9331 10.496 22.7608 10.5478 22.5997C10.5938 22.4567 10.6588 22.3206 10.7413 22.1951C10.8342 22.0536 10.9565 21.9308 11.2012 21.6852L22.1852 10.6588C23.1039 9.73655 24.5963 9.73368 25.5186 10.6524C26.4408 11.5711 26.4437 13.0635 25.525 13.9857L14.5409 25.0121C14.2963 25.2577 14.1739 25.3805 14.0328 25.474C13.9076 25.5569 13.7718 25.6225 13.629 25.669C13.468 25.7215 13.2958 25.7409 12.9513 25.7799L10.1316 26.0987L10.4395 23.2778Z",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7516_9629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.01538 9.01929) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon-pencil.5edda8d0ef314bd2e46904b98e22bbc1.svg";
export { ForwardRef as ReactComponent };